export default "__VITE_ASSET__G69IJqQq__"